// extracted by mini-css-extract-plugin
module.exports = {"crowd":"Crowd_crowd__AJRMf","compareMessage":"Crowd_compareMessage__v0tzv"};